<template>
  <div class="app-container">
    <el-card shadow="never">
      <div slot="header" class="header">
        <span>复制广告(Adq)</span>
        <span>广告主：《{{ this.$route.query.account_name }}》&nbsp;&nbsp;<span>服务商：{{ this.$route.query.service_name }}</span></span>
      </div>
      <div class="top">
        <el-row :gutter="10">
          <el-col :span="4">
            <el-input
              v-model.trim="adqAdvertListParams.adgroup_name"
              placeholder="请输入广告组名称"
            >
              <i slot="prefix" class="el-input__icon el-icon-search" />
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model.trim="adqAdvertListParams.adgroup_id"
              placeholder="请输入广告组ID"
            >
              <i
                slot="prefix"
                class="el-input__icon el-icon-search"
              />
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model.trim="adqAdvertListParams.account_id"
              placeholder="请输入广告主ID"
            >
              <i slot="prefix" class="el-input__icon el-icon-search" />
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model.trim="adqAdvertListParams.account_name"
              placeholder="请输入广告主名称"
            >
              <i slot="prefix" class="el-input__icon el-icon-search" />
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-select
              v-model="adqAdvertListParams.system_status"
              placeholder="请选择"
            >
              <el-option
                v-for="item in system_statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-button type="primary" @click="fetchAdqAdvertList">搜索</el-button>
          <el-button
            type="primary"
            @click="resetTencentAdqAdverList"
          >重置</el-button>
          <el-button type="success" @click="materialSyncbut">
            同步资产
          </el-button>
          <el-button
            type="success"
            :disabled="!isShow"
            @click="handleCopyTencentAdqAdver(adgroup_items, 'batch')"
          >
            批量复制
          </el-button>
        </el-row>
      </div>
      <div class="main">
        <el-table
          v-loading="loading"
          :data="adqAdvertList ? adqAdvertList : []"
          style="width: 100%"
          :row-class-name="'aaaa'"
          :row-key="getRowKeys"
          @select="multipleChoice"
          @select-all="multipleChoice"
        >
          <el-table-column
            type="selection"
            width="55"
            :data-index="1"
            :reserve-selection="true"
          />
          <!-- :selectable="checkSelect" -->

          <!-- <el-table-column
            prop="adgroup_name"
            label="广告名称"
            width="200"
          /> -->
          <el-table-column prop="account_name" label="广告主名称" width="200" />
          <el-table-column prop="account_id" label="广告主id" width="100" />
          <el-table-column prop="adgroup_name" label="广告组名称" width="200" />
          <el-table-column prop="adgroup_id" label="广告组id" />
          <el-table-column prop="configured_status" label="客户设置的状态" />
          <el-table-column prop="system_status_text" label="系统提示" />
          <el-table-column prop="cost_today" label="今日花费" />
          <el-table-column prop="bid_amount" label="出价金额" />
          <el-table-column
            prop="marketing_goal_text"
            label="营销目标"
            width="100"
          />
          <el-table-column
            prop="marketing_carrier_type_text"
            label="营销载体"
            width="100"
          />
          <el-table-column prop="created_at" label="创建时间" />
          <!-- <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="200"
          >
            <template scope="scope">
              <el-button
                type="primary"
                @click="linkskip(scope.row)"
              >复制列表</el-button>
            </template>
          </el-table-column> -->
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleCopyTencentAdqAdver(scope.row)"
              >
                复制
              </el-button>
            </template>
          </el-table-column>
          <publicAdvertList ref="publicAdvertList" />
          <!-- -->
          <!-- <Copylist ref="copyList" /> -->
          <!--
          <CopyAdqAdDialog
            ref="copyAdqAdDialog"
            :adgroup_ids="adgroup_ids"
            @qindian="quedian"
            @guanbi="alone = null"
          />-->
        </el-table>
        <el-dialog
          :visible.sync="sync_copy"
          :destroy-on-close="true"
          title="复制广告"
          width="98%"
          style="height: 90%"
        >
          <AdCopy ref="AdCopyview" :commit_type="type" @close="sync_copy = false" @jobCreated="jobCreated" />
        </el-dialog>
        <PaginationRight
          :total="pageTotal"
          :page.sync="adqAdvertListParams.page"
          :limit.sync="adqAdvertListParams.page_size"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
      </div>
    </el-card>
    <el-dialog
      title="同步账户资产"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="700px"
      append-to-body
    >
      <accoutIdDialog ref="add" @submit="submit" />
    </el-dialog>
  </div>
</template>

<script>
import accoutIdDialog from './CopyAdqAdDialog/accoutIdDialog.vue'
import { adgroupsindex, copy_ad_adq_v3, materialSync } from '@/api/customer.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
// import CopyAdqAdDialog from './CopyAdqAdDialog/index.vue'
import { copyAdqAdvert } from '@/api/customer/accountList/copyAdvertManage'
import publicAdvertList from '@/views/customer/accountList/tencentAdqAdvertManage/publicAdvertList'
import AdCopy from './AdCopy/index.vue'
export default {
  name: 'CopyAdqAdvertManage',
  components: {
    AdCopy,
    PaginationRight,
    publicAdvertList,
    accoutIdDialog
  },
  // CopyAdqAdDialog,
  data() {
    return {
      loading: false,
      loadingGlobalWindow: false,
      pageTotal: 0,
      adqAdvertListParams: {
        adgroup_name: null,
        adgroup_id: null,
        account_id: this.$route.query.account_id || null,
        account_name: null,
        system_status: null,
        page: 1,
        page_size: 10
      },
      adqAdvertList: null,
      adgroup_ids: null,
      alone: null,
      allow_template: null,
      adgroup_items: [],
      system_statusOptions: [
        {
          value: 'ADGROUP_STATUS_FROZEN',
          label: '已冻结'
        },
        {
          value: 'ADGROUP_STATUS_SUSPEND',
          label: '暂停中'
        },
        {
          value: 'ADGROUP_STATUS_NOT_IN_DELIVERY_TIME',
          label: '广告未到投放时间'
        },
        {
          value: 'ADGROUP_STATUS_ACTIVE',
          label: '投放中'
        },
        {
          value: 'ADGROUP_STATUS_DELETED',
          label: '已删除'
        },
        {
          value: 'ADGROUP_STATUS_ACCOUNT_BALANCE_NOT_ENOUGH',
          label: '账户余额不足'
        },
        {
          value: 'ADGROUP_STATUS_DAILY_BUDGET_REACHED',
          label: '广告达到日预算上限'
        },
        {
          value: 'ADGROUP_STATUS_PARTIAL_ACTIVE',
          label: '部分投放中'
        },
        {
          value: 'ADGROUP_STATUS_CREATIVE_STATUS_PENDING',
          label: '创意未投放'
        },
        {
          value: 'ADGROUP_STATUS_CREATIVE_EMPTY',
          label: '创意准备中'
        },
        {
          value: 'ADGROUP_STATUS_JOINT_BUDGET_REACHED',
          label: '广告被暂停（联合预算达上限）'
        }
      ],
      dialogVisible: false,
      sync_copy: false,
      copy_ad_adp_adgroup_id: null,
      copy_ad_adp_adgroup_ids: [],
      copy_ad_adp_account_id: null,
      type: null
    }
  },
  computed: {
    isShow() {
      let blo = false
      console.log('this.adgroup_items:', this.adgroup_items)
      if (this.adgroup_items.length !== 0) {
        const account_id = this.adgroup_items[0].account_id
        // eslint-disable-next-line eqeqeq
        const isAllAccountIdsEqual = this.adgroup_items.every(
          // eslint-disable-next-line eqeqeq
          (item) => item.account_id == account_id
        )

        if (isAllAccountIdsEqual) {
          blo = true
        } else {
          blo = false
        }
      }
      return blo
    }
  },
  created() {
    this.fetchAdqAdvertList()
    console.log(this.$route.query)
    window.aaaaa = this
  },
  methods: {
    handleCopyTencentAdqAdver(rowData, type) {
      if (type === 'batch') {
        rowData.forEach(row => {
          this.copy_ad_adp_adgroup_ids.push(row.adgroup_id)
          this.copy_ad_adp_account_id = row.account_id
        })
      } else {
        this.copy_ad_adp_adgroup_id = rowData.adgroup_id
        this.copy_ad_adp_account_id = rowData.account_id
      }
      console.log('rowDat5a:', rowData)

      this.type = type
      this.sync_copy = true
      if (type === 'batch') {
        console.log('batch:', rowData[0].account_id, rowData[0].marketing_target_type)
        this.$nextTick(() => {
          this.$refs.AdCopyview.sendr(rowData[0].account_id, rowData[0].marketing_target_type)
        })
      } else {
        console.log('不是batch:', rowData)
        this.$nextTick(() => {
          this.$refs.AdCopyview.sendr(rowData.account_id, rowData.marketing_target_type)
        })
      }
    },
    async quedian(obj, fu) {
      console.log('ob56565j888888:', obj)
      if (!this.loadingGlobalWindow) {
        this.loadingGlobalWindow = true
        try {
          const res = await copy_ad_adq_v3(obj)
          console.log('res:', res)
          this.$message.success(res.message)
          this.loadingGlobalWindow = false
          fu()
          this.fetchAdqAdvertList()
        } catch (error) {
          this.loadingGlobalWindow = false
        }
      }
    },
    fetchPageSize(e) {
      console.log('11', e)
      this.adqAdvertListParams.page_size = e
      this.fetchAdqAdvertList()
    },
    fetchCurrentPage(e) {
      console.log('22', e)
      this.adqAdvertListParams.page = e
      this.fetchAdqAdvertList()
    },
    async submit(obj, fu) {
      await materialSync(obj)
      this.$message.success('创建成功')
      setTimeout(() => {
        this.getAdvertiserList()
      }, 2 * 60 * 1000)
      this.handleClose()
      fu()
    },
    handleClose() {
      this.dialogVisible = false
    },
    materialSyncbut(row) {
      this.dialogVisible = true
      console.log(this.adqAdvertListParams.account_id)
      this.$nextTick(() => {
        // eslint-disable-next-line eqeqeq
        if (
          // eslint-disable-next-line eqeqeq
          this.$route.query.account_id == this.adqAdvertListParams.account_id
        ) {
          console.log(1)
          this.$refs.add.send(row, this.$route.query)
        } else {
          let obj = {}
          if (this.adqAdvertListParams.account_id !== '') {
            console.log(2, this.adqAdvertListParams.account_id)
            this.adqAdvertList.forEach((element) => {
              // eslint-disable-next-line eqeqeq
              if (element.account_id == this.adqAdvertListParams.account_id) {
                obj = {
                  account_id: element.account_id,
                  account_name: element.account_name
                }
              }
            })
          }
          this.$refs.add.send(row, obj)
        }
      })
    },
    linkskip(row) {
      this.$router.push({
        path: '/tencentAD/copyRecord/index',
        query: { item: row }
      })
    },
    // 获取广告列表
    fetchAdqAdvertList() {
      this.loading = true
      adgroupsindex(this.adqAdvertListParams).then((res) => {
        this.adqAdvertList = res.data.list
        this.pageTotal = res.data.count

        // this.allow_template = res.data.allow_template
        // this.loadTheFirstPin(this.adqAdvertList)
        // this.pageTotal = res.data.page_info.total_number
        this.loading = false
      })
    },
    // 搜索公共广告
    searchTencentAdqAdver() {
      if (this.adqAdvertListParams.adgroup_name === '') {
        this.adqAdvertListParams.adgroup_name = null
      }
      this.adqAdvertListParams.page = 1
      this.fetchAdqAdvertList()
    },
    // 重置公共广告
    resetTencentAdqAdverList() {
      this.adqAdvertListParams = {
        account_name: null,
        adgroup_name: null,
        adgroup_id: null,
        account_id: this.$route.query.account_id,
        dynamic_creative_name: null,
        page: 1,
        page_size: 10
      }
      this.fetchAdqAdvertList()
    },
    multipleChoice(arr) {
      console.log('arr:', arr)
      this.adgroup_ids = arr.map((item) => {
        return item.adgroup_id
      })
      this.adgroup_items = arr
    },
    async qindian(data1, func) {
      let obj = null
      // 判断是否不是批量复制
      if (this.alone) {
        obj = {
          origin: '2',
          account_id: this.$route.query.account_id,
          account_ids: data1,
          adgroup_ids: [this.alone.adgroup_id]
        }
      } else {
        obj = {
          origin: '2',
          account_id: this.$route.query.account_id,
          account_ids: data1,
          adgroup_ids: this.adgroup_ids
        }
      }
      copyAdqAdvert(obj)
        .then((data) => {
          this.$message({
            message: data.message,
            type: 'success'
          })
          func()
        })
        .catch((data) => {
          this.$message({
            message: `${data.message}`,
            type: 'error'
          })
        })
    },
    // loadTheFirstPin(list) {
    //   for (let i = 0; i < list.length; i++) {
    //     if (!list[i].preview_info.img && list[i].preview_info.video) {
    //       diyi(list[i].preview_info, list[i].preview_info.video)
    //     }
    //   }

    //   const This = this

    //   function diyi(obj, src) {
    //     var videoElement = document.createElement('video')
    //     videoElement.src = src
    //     videoElement.addEventListener('canplay', function () {
    //       var canvas = document.createElement('canvas')
    //       canvas.width = videoElement.videoWidth
    //       canvas.height = videoElement.videoHeight
    //       canvas.getContext('2d').drawImage(videoElement, 0, 0, canvas.width, canvas.height)
    //       var firstFrame = canvas.toDataURL('image/png') // 第一帧图片url
    //       This.$set(obj, 'firstStitch', firstFrame)
    //     })
    //   }
    // },
    checkSelect(row, index) {
      return this.allow_template.includes(
        row.preview_info.adcreative_template_id
      )
    },
    getRowKeys(row) {
      return row.adgroup_id
    },
    jobCreated(val, type, chuanappid) {
      if (type === 'batch') {
        copy_ad_adq_v3({
          account_id: this.copy_ad_adp_account_id,
          account_ids: val,
          adgroup_ids: this.copy_ad_adp_adgroup_ids,
          marketing_asset_ids: chuanappid
        }).then(res => {
          if (res.code === 0) {
            this.$message.success(res.message)
          }
        })
      } else {
        copy_ad_adq_v3({
          account_id: this.copy_ad_adp_account_id,
          account_ids: val,
          adgroup_ids: [this.copy_ad_adp_adgroup_id],
          marketing_asset_ids: chuanappid
        }).then(res => {
          if (res.code === 0) {
            this.$message.success(res.message)
          }
        })
      }
      this.sync_copy = false
      this.copy_ad_adp_adgroup_ids = []
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
}
.main {
  margin-top: 20px;
  video {
    width: 100px;
    height: 100px;
    object-fit: fill;
  }
  .shadowBox {
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: center;
  }
}
.titip {
  width: 154px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 这里是超出几行省略 */
  overflow: hidden;
}
</style>
